// extracted by mini-css-extract-plugin
export var infoItem = "_p3-2";
export var title = "_p3-0";
export var value = "_p3-1";